/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // NPM: Apollo client for handling graphql request.

/*
 * GRAPH
 */
const Index = gql`
mutation MyMutation($brandNameId: ID!, $duration: Int!) {
    BrandSubscriptionDetailsCreate(brandNameId: $brandNameId, duration: $duration) {
      message
      status
    }
  }
`;

/*
 * EXPORTS
 */
export default Index;
